import React from "react";
import { Button } from "./ui/button";
import { Reveal } from "../hooks/useReveal";
import { Bell } from "lucide-react";
import { LAUNCH_LABEL } from "../mock";

export default function WaitlistBanner({ onWaitlist }) {
  return (
    <section className="relative py-16">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative flex flex-col items-center text-center rounded-3xl border border-[#2fd645]/30 bg-[#0e1311] px-6 py-12 overflow-hidden">
            <div className="absolute inset-0 id-radial opacity-70" />
            <div className="relative flex flex-col items-center">
              <div className="inline-flex items-center gap-2 rounded-full border border-[#2fd645]/30 bg-[#2fd645]/10 px-4 py-1.5 mb-5">
                <Bell className="h-4 w-4 text-[#2fd645]" />
                <span className="text-xs font-bold uppercase tracking-widest text-[#2fd645]">
                  Be first in line
                </span>
              </div>
              <h2 className="font-display font-extrabold text-white text-3xl sm:text-4xl max-w-2xl">
                Don&apos;t miss launch day &mdash; {LAUNCH_LABEL}
              </h2>
              <p className="mt-4 text-white/65 text-lg max-w-xl">
                Join the waitlist now and we&apos;ll notify you the moment InstantDrive goes live.
              </p>
              <Button
                onClick={onWaitlist}
                className="mt-8 h-16 px-12 text-lg font-extrabold uppercase tracking-wide bg-[#2fd645] text-[#06210b] hover:bg-[#46ff5c] rounded-2xl shadow-[0_0_40px_-6px_rgba(47,214,69,0.6)] transition-transform hover:scale-[1.04]"
              >
                Join the Waitlist
              </Button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
